import React from 'react';
import MarketingNav from '../components/MarketingNav';
import MarketingFooter from '../components/MarketingFooter';

const C = { void:'#030A3C', cyan:'#00FFFF', white:'#F8F9FA', muted:'rgba(248,249,250,0.72)', muted2:'rgba(248,249,250,0.72)', border:'rgba(0,255,255,0.08)', border2:'rgba(0,255,255,0.15)' };

const Section = ({ title, children }) => (
  <div style={s.section}>
    <h2 style={s.h2}>{title}</h2>
    {children}
  </div>
);

const Table = ({ rows }) => (
  <table style={s.table}>
    <thead>
      <tr>{rows[0].map((h, i) => <th key={i} style={s.th}>{h}</th>)}</tr>
    </thead>
    <tbody>
      {rows.slice(1).map((row, i) => (
        <tr key={i}>{row.map((cell, j) => <td key={j} style={s.td}>{cell}</td>)}</tr>
      ))}
    </tbody>
  </table>
);

export default function Cookies() {
  function openPreferences() {
    localStorage.removeItem('scq_cookie_consent');
    window.location.reload();
  }

  return (
    <div style={s.root}>
      <MarketingNav />

      <div style={s.hero}>
        <div style={s.heroBg} />
        <div style={s.eyebrow}>Legal</div>
        <h1 style={s.h1}>Cookie Policy</h1>
        <p style={s.heroSub}>Last updated: 20 March 2026</p>
      </div>

      <div style={s.body}>
        <div style={s.inner}>

          <Section title="1. What Are Cookies">
            <p style={s.p}>Cookies are small text files stored on your device when you visit a website. We use cookies and similar tracking technologies on sensecritiq.com to keep you signed in and, with your consent, to understand how the site is used.</p>
          </Section>

          <Section title="2. Strictly Necessary Cookies">
            <p style={s.p}>These cookies are required for the site to function and cannot be disabled. They are set by Clerk, our authentication provider, and are essential to keep you signed in.</p>
            <Table rows={[
              ['Cookie', 'Purpose', 'Duration'],
              ['__session', 'Clerk authentication token', 'Session'],
              ['__client_uat', 'Clerk cross-tab session sync', '1 year'],
            ]} />
          </Section>

          <Section title="3. Analytics Cookies">
            <p style={s.p}>These cookies are only set if you accept analytics in the cookie banner. They help us understand how visitors use the site so we can improve it. No personally identifiable information is collected.</p>

            <p style={s.p}><strong style={s.strong}>Google Analytics</strong></p>
            <Table rows={[
              ['Cookie', 'Purpose', 'Duration'],
              ['_ga', 'Distinguishes unique users', '2 years'],
              ['_ga_*', 'Maintains session state', '2 years'],
              ['_gid', 'Distinguishes users (24h window)', '24 hours'],
            ]} />
            <p style={s.p}>Data is transferred to Google LLC in the USA under Standard Contractual Clauses. You can opt out at any time via the <a href="https://tools.google.com/dlpage/gaoptout" style={s.link} target="_blank" rel="noopener noreferrer">Google Analytics Opt-out Browser Add-on</a>.</p>

            <p style={s.p}><strong style={s.strong}>Microsoft Clarity</strong></p>
            <Table rows={[
              ['Cookie', 'Purpose', 'Duration'],
              ['_clck', 'Persists Clarity user ID', '1 year'],
              ['_clsk', 'Connects page views within a session', '24 hours'],
              ['MUID', 'Identifies browsers across Microsoft domains', '1 year'],
            ]} />
            <p style={s.p}>Data is transferred to Microsoft Corporation in the USA under Standard Contractual Clauses. Microsoft Clarity may record mouse movements and clicks (session replay) to help us identify usability issues.</p>
          </Section>

          <Section title="4. Your Choices">
            <p style={s.p}>When you first visit sensecritiq.com, a banner asks for your consent before any analytics cookies are set. You can:</p>
            <ul style={s.ul}>
              <li style={s.li}><strong style={s.strong}>Accept all</strong> — enables Google Analytics and Microsoft Clarity</li>
              <li style={s.li}><strong style={s.strong}>Reject non-essential</strong> — only strictly necessary cookies are set</li>
            </ul>
            <p style={s.p}>You can change your preferences at any time:</p>
            <button style={s.prefBtn} onClick={openPreferences}>Open cookie preferences</button>
          </Section>

          <Section title="5. Contact">
            <p style={s.p}>Questions about our use of cookies: <a href="mailto:privacy@sensecritiq.com" style={s.link}>privacy@sensecritiq.com</a></p>
          </Section>

        </div>
      </div>

      <MarketingFooter />
    </div>
  );
}

const s = {
  root: { background: C.void, minHeight: '100vh', fontFamily: "'Inter',sans-serif", color: C.white },
  hero: { textAlign: 'center', padding: '80px 24px 60px', position: 'relative', overflow: 'hidden' },
  heroBg: { position: 'absolute', inset: 0, background: 'radial-gradient(ellipse 60% 50% at 50% 0%, rgba(0,255,255,0.07) 0%, transparent 65%)', pointerEvents: 'none' },
  eyebrow: { fontSize: 11, fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: C.cyan, marginBottom: 16, position: 'relative' },
  h1: { fontFamily: "'Satoshi','Inter',sans-serif", fontSize: 'clamp(28px,4vw,48px)', fontWeight: 700, letterSpacing: '-0.03em', lineHeight: 1.1, marginBottom: 14, position: 'relative' },
  heroSub: { fontSize: 14, color: C.muted2, position: 'relative' },
  body: { padding: '0 24px 80px' },
  inner: { maxWidth: 1100, margin: '0 auto' },
  section: { borderTop: `1px solid ${C.border}`, paddingTop: 36, marginTop: 36 },
  h2: { fontFamily: "'Satoshi','Inter',sans-serif", fontSize: 20, fontWeight: 700, letterSpacing: '-0.02em', marginBottom: 16, color: C.white },
  p: { fontSize: 15, color: C.muted, lineHeight: 1.75, marginBottom: 14 },
  ul: { paddingLeft: 20, margin: '0 0 14px' },
  li: { fontSize: 15, color: C.muted, lineHeight: 1.75, marginBottom: 8 },
  strong: { color: C.white, fontWeight: 600 },
  link: { color: C.cyan, textDecoration: 'none' },
  table: { width: '100%', borderCollapse: 'collapse', marginBottom: 16, fontSize: 14 },
  th: { textAlign: 'left', padding: '8px 12px', borderBottom: `1px solid ${C.border2}`, color: C.white, fontWeight: 600 },
  td: { padding: '8px 12px', borderBottom: `1px solid ${C.border}`, color: C.muted, verticalAlign: 'top' },
  prefBtn: { padding: '10px 18px', background: 'rgba(0,255,255,0.10)', color: C.cyan, border: `1px solid rgba(0,255,255,0.15)`, borderRadius: 9, fontSize: 13, fontFamily: "'Satoshi','Inter',sans-serif", fontWeight: 700, cursor: 'pointer' },
};
